export const FilterChip = ({ label, value, onClick, onClear, disabled = false }) => {
  const isActive = value !== null && value !== false;
  // console.log("isActive", isActive)
  // console.log("value ", value)
  return (
    <div
      className={`filter-chip 
        ${isActive ? "active" : ""} 
        ${disabled ? "disabled" : ""}
      `}
      onClick={!disabled && !isActive ? onClick : undefined}
    >
      <span>{isActive ? value || label : label}</span>

      {isActive && !disabled && (
        <span
          className="filter-clear"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
        >
        <i className="fa-regular fa-x fa-sm" style={{ color: "#fff" }}></i>
        </span>
      )}
    </div>
  );
};
